import * as PartnerEffects from './partners.effect';

export const effects = { ...PartnerEffects };
